
import Button from '../base/Button';

export default function Pricing() {
  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            One flat rate covers unlimited invoices. No per-transaction fees, no hidden costs.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Beta Pricing */}
            <div className="relative bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 border-2 border-green-200 shadow-xl">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-green-500 text-white px-6 py-2 rounded-full text-sm font-bold">
                  BETA SPECIAL - 50% OFF
                </span>
              </div>
              
              <div className="text-center mt-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Beta Access</h3>
                <div className="mb-6">
                  <span className="text-5xl font-bold text-green-600">$49.50</span>
                  <span className="text-gray-600 ml-2">/month</span>
                  <div className="text-sm text-gray-500 mt-1">
                    <span className="line-through">$99/month</span> - Save 50%
                  </div>
                </div>
                
                <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-sm font-medium mb-6">
                  Plus $4.95 one-time testing fee
                </div>
                
                <Button variant="secondary" size="lg" className="w-full mb-6">
                  <i className="ri-rocket-line mr-2"></i>
                  Join Beta & Save 50%
                </Button>
                
                <ul className="text-left space-y-3 text-sm">
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                    Unlimited invoice processing
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                    QuickBooks & MSBC integration
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                    Secure cloud storage
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                    Manual approval workflow
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                    Priority beta support
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                    Lock in this price forever
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Regular Pricing */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Full Release</h3>
                <div className="mb-6">
                  <span className="text-5xl font-bold text-gray-900">$99</span>
                  <span className="text-gray-600 ml-2">/month</span>
                </div>
                
                <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-sm font-medium mb-6">
                  Available after beta period
                </div>
                
                <Button size="lg" className="w-full mb-6">
                  <i className="ri-play-circle-line mr-2"></i>
                  Start Free Trial
                </Button>
                
                <ul className="text-left space-y-3 text-sm">
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-blue-500 mr-3"></i>
                    Unlimited invoice processing
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-blue-500 mr-3"></i>
                    All accounting integrations
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-blue-500 mr-3"></i>
                    Advanced reporting
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-blue-500 mr-3"></i>
                    Custom approval rules
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-blue-500 mr-3"></i>
                    Premium support
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-circle-fill text-blue-500 mr-3"></i>
                    API access
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <p className="text-gray-600 mb-6">
              <strong>Calculate your savings:</strong> Average SMB processes 200 invoices/month at 10 minutes each = 33 hours saved monthly
            </p>
            <div className="bg-gray-50 rounded-xl p-6 max-w-2xl mx-auto">
              <div className="text-sm text-gray-600 space-y-2">
                <div className="flex justify-between">
                  <span>Time saved per month:</span>
                  <span className="font-semibold">33 hours</span>
                </div>
                <div className="flex justify-between">
                  <span>Average hourly cost (clerk/outsourcing):</span>
                  <span className="font-semibold">$15/hour</span>
                </div>
                <div className="flex justify-between border-t pt-2">
                  <span className="font-bold">Monthly savings:</span>
                  <span className="font-bold text-green-600">$495</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-bold">ROI with Ledger Linc:</span>
                  <span className="font-bold text-green-600">400%+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
